var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-results" },
    [
      _c("transition", { attrs: { name: "component-fade", mode: "out-in" } }, [
        _vm.ready
          ? _c(
              "div",
              { key: "ready" },
              [
                _vm.products.length > 0
                  ? _c(
                      "product-rows",
                      { attrs: { products: _vm.products } },
                      [_vm._t("default")],
                      2
                    )
                  : _c("p", [_vm._v("Geen producten gevonden")])
              ],
              1
            )
          : _c(
              "div",
              { key: "loading", staticClass: "loading" },
              [_c("spinner")],
              1
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }